import { ref } from 'vue';
import { useFlutterConnection } from '@/composables/useFlutterConnection';
import { Remind } from '@/modules/Remind';
import { User } from '@/modules/User';
import Repository from './client/ApiAxiosClient';

const resource = '/user';

interface CreateUserResponse {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  survey: null;
}

export const useUserRepository = () => {
  const user = ref<User>({
    id: null,
  });

  /**
   * ユーザーを作成する
   * アプリ起動時に、認証キーの取得が間に合わない可能性がある為、明示的に待つ
   */
  const create = async () => {
    const { data } = await Repository.post<CreateUserResponse>(`${resource}`).catch((e) => {
      throw e;
    });
    user.value.id = data.id;
    return data;
  };

  /**
   * リマインドの時間情報を更新する
   */
  const updateRemindTime = async (userId: number, remindTimeData: Remind['time']) => {
    const { data } = await Repository.put(`${resource}/${userId}/notify-time`, {
      remind_notify_time: remindTimeData,
    }).catch((e) => {
      throw e;
    });
    return data;
  };

  /**
   * リマインドのチャンネル情報を更新する
   */
  const updateRemindChannel = async (userId: number, remindChannelData: Remind['channel']) => {
    const { data } = await Repository.put(`${resource}/${userId}/notify-channel`, {
      channel_type: remindChannelData,
    }).catch((e) => {
      throw e;
    });

    return data;
  };

  /**
   * リマインドの設定情報を取得する
   */

  const getRemindSettingData = async (userId: number): Promise<Remind> => {
    const { data } = await Repository.get(`${resource}/${userId}`).catch((e) => {
      throw e;
    });

    const result: Remind = {
      time: data.remindNotifyTime,
      channel: data.channelType,
    };
    return result;
  };

  return {
    create,
    user,
    updateRemindTime,
    updateRemindChannel,
    getRemindSettingData,
  };
};

export type UserRepository = ReturnType<typeof useUserRepository>;
